import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserDataService, UserInfo } from '../../data-services/user-data.service';
import { EMPTY, Observable, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { redirectToURL } from '../../services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'ah-activate-user',
    templateUrl: './activate-user.component.html',
    styleUrls: ['./activate-user.component.scss'],
    standalone: false
})

export class ActivateUserComponent implements OnInit, OnDestroy {
    userInfo$?: Observable<UserInfo>;
    private subs?: Subscription;
    code!: string;

    constructor(
        private route: ActivatedRoute,
        private userDataService: UserDataService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit(): void {
        this.subs = new Subscription();

        this.code = this.route.snapshot.queryParams['code'];
        this.userInfo$ = this.userDataService.getUserByToken(this.code).pipe(
            catchError((err) => {
                const message = err?.error?.message || 'User is invalid or expired token.';
                this.snackBar.open(message, 'Ok', {
                    panelClass: ['customize']
                });
                return EMPTY;
            })
        );
    }

    proceed(event: any) {
        const pathSub = this.userDataService.activateUser({ ...event.userInfo, token: this.code });

        this.subs?.add(pathSub.subscribe({
            next: (value: any) => {
                redirectToURL(value.path);
            },
            error: (err) => {
                const message = err?.error?.message || 'User is invalid or expired token.';
                this.snackBar.open(message, 'Ok', {
                    panelClass: ['customize']
                });
            }
        }));
    }

    ngOnDestroy(): void {
        this.subs?.unsubscribe();
    }
}